export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9687.e08e7a2d.jpg";